import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let diffExample = `# Compare the output of two commands without writing temp files
diff <(sort file1.txt) <(sort file2.txt)

diff <(curl -s https://a.example.com/health) <(curl -s https://b.example.com/health)`

let inputExample = `# Feed a command's output as if it were a file
while read -r line; do
    echo "got: $line"
done < <(grep "ERROR" app.log)`

let outputExample = `# Send a command's output as if it were an output file
tar cf >(gzip > backup.tar.gz) files/`

export default function ProcessSubstitution() {
    return (
        <div className={globalStyles.article}>
            <h1>Process substitution</h1>
            <p><code>{"<(cmd)"}</code> and <code>{">(cmd)"}</code> let a command's input or output be treated
                as a file, backed by a temporary FIFO or <code>/dev/fd</code> entry — bash/zsh/ksh only, not
                POSIX <code>sh</code>.</p>

            <h3>&lt;(cmd) — use a command's output as a file</h3>
            <p>The classic use case: diffing two command outputs directly.</p>
            <SyntaxHighlighter
                children={diffExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Feeding a while loop without a subshell</h3>
            <p><code>cmd | while read ...</code> runs the loop in a subshell, so variables set inside it are
                lost afterward. Redirecting from <code>{"<(cmd)"}</code> instead keeps the loop in the current
                shell.</p>
            <SyntaxHighlighter
                children={inputExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>&gt;(cmd) — use a command's input as a file</h3>
            <p>Less common, but useful for streaming output straight into another process, e.g. compressing a
                tar stream on the fly.</p>
            <SyntaxHighlighter
                children={outputExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
